import React from 'react';
import Icon from './Icon';

const Chat = (props) => (
  <Icon viewBox="0 0 19 19" {...props}>
    <title>Chat</title>
    <g id="New-UX" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
      <g id="My-Account/Rewards" transform="translate(-704.000000, -557.000000)" stroke="#003953">
        <g id="chat-icon" transform="translate(705.000000, 558.000000)">
          <path d="M15.8913043,0 L1.10869565,0 C0.496377678,0 0,0.479692714 0,1.07142857 L0,11.0714286 C0,11.6631644 0.496377678,12.1428571 1.10869565,12.1428571 L2.95652174,12.1428571 L2.95652174,15 L5.91304348,12.1428571 L15.8913043,12.1428571 C16.5036223,12.1428571 17,11.6631644 17,11.0714286 L17,1.07142857 C17,0.479692714 16.5036223,0 15.8913043,0 Z" id="Shape"/>
        </g>
      </g>
    </g>
  </Icon>
);

export default Chat;
